import {
  IconArrowBigDownLine,
  IconArrowBigUpLineFilled,
} from '@tabler/icons-react';

export const FactoryInputIcon = IconArrowBigDownLine;
export const FactoryOutputIcon = IconArrowBigUpLineFilled;
